import React from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

function CartIcon() {
  const { summary, loading } = useCart();
  const navigate = useNavigate();

  const handleCartClick = () => {
    navigate('/cart');
  };

  return (
    <div className="cart-icon" onClick={handleCartClick}>
      <div className="cart-icon-container">
        <svg 
          className="cart-svg" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" 
          />
        </svg>
        
        {summary.itemCount > 0 && (
          <span className="cart-badge">
            {summary.itemCount}
          </span>
        )}
      </div>
      
      <div className="cart-summary">
        <span className="cart-total">
          ${summary.totalPrice.toFixed(2)}
        </span>
      </div>
    </div>
  );
}

export default CartIcon;